import { render } from "./McModal.vue?vue&type=template&id=83482fd4"
import script from "./McModal.vue?vue&type=script&lang=js"
export * from "./McModal.vue?vue&type=script&lang=js"

import "./McModal.vue?vue&type=style&index=0&id=83482fd4&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__